import { resourceSelectors } from '../../utils/resourceSelectors';

export const [
  alternativeAssetsAllIds,
  alternativeAssetsById,
  allAlternativeAssetsSelector,
  alternativeAssetsMeta,
] = resourceSelectors('alternativeAssets');
